class MCBQuickBuyButton extends HTMLElement {
  constructor() {
    super();
    this.variantSelectorTemplate = this.querySelector('.variant-selector-template');
    this.viewVariantsButton = this.querySelector('[data-open-variant-selector]');
    this.hasVariants = this.variantSelectorTemplate !== null;
    this.isLoading = false;
    
    this.setupEventListeners();
    
    document.addEventListener('on:cart:add', () => {
      if (this.variantSelector) {
        this.hideVariantSelector();
      }
    });
  }

  setupEventListeners() {
    if (this.hasVariants) {
      this.viewVariantsButton.addEventListener('click', () => {
        if (!this.isLoading) {
          this.showVariantSelector();
        }
      });
    }
  }

  handleVariantChange(event, addToCartButton) {
    const selectedValue = event.target.value;
    const isValidVariant = selectedValue !== '0';
    
    addToCartButton.disabled = !isValidVariant;
    
    this.querySelector('.js-product').dispatchEvent(new CustomEvent('on:variant:change', {
      bubbles: true,
      detail: {
        variant: { id: selectedValue },
      }
    }));
  }

  hideVariantSelector() {
    if (this.variantSelector) {
      const variantSelect = this.querySelector('.variant-selector');
      const closeButton = this.querySelector('.variant-selector-close');
      
      variantSelect.removeEventListener('change', this.boundVariantChangeHandler);
      closeButton.removeEventListener('click', this.boundHideVariantSelector);
      
      this.variantSelector.remove();
      this.variantSelector = null;
      this.boundVariantChangeHandler = null;
      this.boundHideVariantSelector = null;
    }
  }

  showVariantSelector() {
    if (this.variantSelector) {
      this.hideVariantSelector();
      return;
    }

    const template = this.variantSelectorTemplate;
    const fragment = template.content.cloneNode(true);
    this.appendChild(fragment);
    
    this.variantSelector = this.querySelector('.variant-selector-wrapper');
    const closeButton = this.querySelector('.variant-selector-close');
    const variantSelect = this.querySelector('.variant-selector');
    const addToCartButton = this.querySelector('.add-to-cart-button');

    this.boundVariantChangeHandler = (event) => this.handleVariantChange(event, addToCartButton);
    this.boundHideVariantSelector = () => this.hideVariantSelector();

    variantSelect.addEventListener('change', this.boundVariantChangeHandler);
    closeButton.addEventListener('click', this.boundHideVariantSelector);
  }
}

customElements.define('mcb-quickbuy-button', MCBQuickBuyButton); 